var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { SortService } from "~/utils/sort.service";
import { PageService } from "~/utils/page.service";
import { Emit, Prop } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseFollowRecordService } from "~/services/business-service/case-follow-record.service";
var collectionManageModule = namespace("collection-manage");
var ReportLookMark = /** @class */ (function (_super) {
    __extends(ReportLookMark, _super);
    function ReportLookMark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.loading = {
            state: false
        };
        return _this;
    }
    ReportLookMark.prototype.close = function () { };
    ReportLookMark.prototype.refreshData = function () {
        this.getSearchComment();
    };
    ReportLookMark.prototype.getSearchComment = function () {
        var _this = this;
        var queryParamsModel = {
            caseId: this.caseId,
            commentTypeList: ["REPORT_POSTIL"]
        };
        this.loading.state = true;
        this.caseFollowRecordService.getCommentByType(queryParamsModel, this.loading).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(SortService)
    ], ReportLookMark.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], ReportLookMark.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseFollowRecordService)
    ], ReportLookMark.prototype, "caseFollowRecordService", void 0);
    __decorate([
        Prop()
    ], ReportLookMark.prototype, "caseId", void 0);
    __decorate([
        Emit("close")
    ], ReportLookMark.prototype, "close", null);
    ReportLookMark = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], ReportLookMark);
    return ReportLookMark;
}(Vue));
export default ReportLookMark;
